import { z } from "zod";

// SSL status schema
export const CfSslSchema = z
    .object({
        status: z.string().nullable().optional(),
        method: z.string().nullable().optional(),
        http_url: z.string().nullable().optional(),
        http_body: z.string().nullable().optional(),
        certificate_authority: z.string().nullable().optional(),
    })
    .nullable();

export type CfSsl = z.infer<typeof CfSslSchema>;

// Ownership verification schema (TXT record for hostname pre-validation)
export const CfOwnershipVerificationSchema = z
    .object({
        type: z.string().nullable().optional(),
        name: z.string().nullable().optional(),
        value: z.string().nullable().optional(),
    })
    .nullable();

export type CfOwnershipVerification = z.infer<
    typeof CfOwnershipVerificationSchema
>;

// DNS validation record schema
export const DnsValidationRecordSchema = z.object({
    valid: z.boolean(),
    current: z.string().nullable(),
});

export type DnsValidationRecord = z.infer<typeof DnsValidationRecordSchema>;

// DNS validation schema
export const DnsValidationSchema = z
    .object({
        cname: DnsValidationRecordSchema,
        txt: DnsValidationRecordSchema.optional(),
    })
    .nullable();

export type DnsValidation = z.infer<typeof DnsValidationSchema>;

// Response DTO schema
export const PageDomainDTOSchema = z.object({
    id: z.number().int().positive(),
    team_id: z.number().int().positive(),
    domain: z.string(),
    is_default: z.boolean(),
    verified_at: z.string().nullable(),
    cf_status: z.string().nullable(),
    cf_hostname_id: z.string().nullable(),
    cf_ssl: CfSslSchema.optional(),
    cf_ownership_verification: CfOwnershipVerificationSchema.optional(),
    dns_validation: DnsValidationSchema.optional(),
    team_name: z.string().nullable().optional(),
    is_personal_team: z.boolean().optional(),
});

export type PageDomainDTO = z.infer<typeof PageDomainDTOSchema>;

// Form schema - used for real-time validation in forms
export const PageDomainFormSchema = z.object({
    domain: z
        .string()
        .min(1, "Domain is required")
        .max(255, "Domain cannot exceed 255 characters"),
    is_default: z.boolean().optional().default(false),
    team_id: z.number().int().positive().nullable().optional(),
});

export type PageDomainFormData = z.infer<typeof PageDomainFormSchema>;

// Request schemas - mirrors Laravel validation rules (for API calls)
export const StorePageDomainRequestSchema = z.object({
    domain: z
        .string()
        .min(1, "Domain is required")
        .max(255, "Domain cannot exceed 255 characters"),
    is_default: z.boolean().optional().default(false),
    team_id: z.number().int().positive().nullable().optional(),
});

export type StorePageDomainRequest = z.infer<
    typeof StorePageDomainRequestSchema
>;

export const UpdatePageDomainRequestSchema = z.object({
    domain: z
        .string()
        .min(1, "Domain is required")
        .max(255, "Domain cannot exceed 255 characters"),
});

export type UpdatePageDomainRequest = z.infer<
    typeof UpdatePageDomainRequestSchema
>;
